export class RetailSubscription{

    chargeBeePlanId: number;
    storeSubscriptionType: number;
    opCoSubscriptionType: number;
    designateStoreId: number;
}


// WEBPACK FOOTER //
// ./src/app/customerservice/interface/retail-subscription.ts